// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","container":"header_container__7HyC8","logoContainer":"header_logoContainer__toWx2"};